.dot {
  cursor: pointer; }
